import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { catchError, Observable, of } from "rxjs";
export enum DocumentType {
  IMPRINT = "IMPRINT",
  DATA_PRIVACY = "DATA_PRIVACY",
  LEGAL_NOTICE = "LEGAL_NOTICE",
}

@Injectable({
  providedIn: "root",
})
export class LegalInformationService {
  private httpClient = inject(HttpClient);

  private readonly documentsMap: Record<
    string,
    { [DocumentType.IMPRINT]: string; [DocumentType.DATA_PRIVACY]: string; [DocumentType.LEGAL_NOTICE]: string }
  > = {
    "de-DE": {
      [DocumentType.IMPRINT]: "impressum-draeger-safety-ag-co-kgaa.pdf",
      [DocumentType.DATA_PRIVACY]: "dse-web-navinta-de.pdf",
      [DocumentType.LEGAL_NOTICE]: "rechtliche-hinweise.pdf",
    },
    "en-US": {
      [DocumentType.IMPRINT]: "provider-identification-draeger-safety-ag-co-kgaa.pdf",
      [DocumentType.DATA_PRIVACY]: "dse-web-navinta-en.pdf",
      [DocumentType.LEGAL_NOTICE]: "legal-notice.pdf",
    },
  };

  getLegalDocumentLink(languageCode: string, documentType: DocumentType): string {
    if (!this.documentsMap[languageCode]) {
      languageCode = "en-US";
    }
    return "assets/legal-documents/" + this.documentsMap[languageCode][documentType];
  }

  loadLegalDocument(languageCode: string, documentType: DocumentType): Observable<Blob | undefined> {
    const url = this.getLegalDocumentLink(languageCode, documentType);
    return this.httpClient.get(url, { responseType: "blob" }).pipe(catchError(() => of(undefined)));
  }
}
